<template lang="">
  <div class="flex flex-row w-screen">
    <div class="w-full">
      <!--  -->

      <div
        class="lg:flex lg:items-center lg:justify-between my-4 lg:mx-12 mx-12"
      >
        <div class="flex justify-center lg:justify-start mt-4 min-w-0">
          <div>
            <h2
              class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl"
            >
              All Projects
            </h2>
          </div>
        </div>
        <div
          class="mt-4 gap-3 w-min flex flex-col justify-center md:flex-row lg:mt-0 lg:ml-4"
        >
          <button
            v-if="$store.state.permissions.addProject"
            @click="displayProjectModal = true"
            class="py-2 px-4 mt-2 mx-2 bg-woo rounded-lg text-white font-semibold"
          >
            Add project
          </button>
        </div>
      </div>

      <GoodTable
        :key="counter"
        :name="'project'"
        :rows="projects"
        :columns="columns"
        :method1="ViewBatches"
        :method2="DeleteProject"
      />

      <AddProjectModal
        v-if="displayProjectModal"
        @addProject="addProject"
        @close="displayProjectModal = false"
      />
    </div>
  </div>
</template>

<script>
import Http, { OCR_ENDPOINTS } from "../request";
import AddProjectModal from "../components/AddProjectModal.vue";
import GoodTable from "../components/GoodTable.vue";
import moment from "moment";
import Vue from "vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { mapState } from "vuex";

// Vue.use(Toast, {
//     // registration props here
//     position: 'top-center'
// });

export default {
  created() {
    this.getProjects();
    this.modifyData();
  },

  components: {
    GoodTable,
    AddProjectModal,
  },
  data() {
    return {
      counter: 0,
      displayUserModal: false,
      deleteProject: false,
      displayProjectModal: false,
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Batches",
          field: "numberOfBatches",
          type: "number",
        },
        {
          label: "Users",
          field: "numberOfUsers",
          type: "number",
        },
        {
          label: "Created On",
          field: "creationDate",
        },
        {
          label: "Active",
          field: "active",
          type: "boolean",
        },
        {
          label: "Actions",
          field: "actions",
          sortable: false,
        },
      ],
      projects: [],
    };
  },
  computed: {
    ...mapState("loader", ["loading"]),
  },
  methods: {
    addUsers(projectId, users) {
      Http().post(OCR_ENDPOINTS.projects + "/" + projectId + "/users"),
        {
          userIdList: users,
        }
          .then((response) => {
            console.log(response);
          })
          .finally(() => {});
    },

    DeleteProject(projectId) {
      Http()
        .patch(OCR_ENDPOINTS.projects + projectId + "/active")
        .then((response) => {
          this.newProject = response.data;
          let status = response.data.active;
          if (status) {
            this.$toast.success("Project activated succesfully");
          } else {
            this.$toast.success("Project deactivated succesfully");
          }
          this.afterDelete(projectId);
        })
        .finally(() => {});
    },

    afterDelete(projectId) {
      const projectIndex = this.projects.findIndex(
        (project) => project.id == projectId
      );
      this.projects[projectIndex] = this.newProject;
      this.modifyData();
      this.counter++;
    },

    ViewBatches(projectId) {
      this.$router.push(`batches/?projectId=${projectId}`);
    },

    modifyData() {
      for (var i = 0; i < this.projects.length; i++) {
        // this.projects[i].batches = this.projects[i].batches.length
        // this.projects[i].defaultImageType = this.projects[i].defaultImageType.name
        this.projects[i].creationDate = moment(
          this.projects[i].creationDate
        ).format("YYYY-MM-DD hh:mm");
      }
    },
    modifyNew(obj) {
      obj.creationDate = moment(obj.creationDate).format("YYYY-MM-DD hh:mm a");
    },

    getProjects() {
      Http()
        .get(OCR_ENDPOINTS.projects, {
          params: {
            page: 0,
            size: 1000,
          },
          showLoader: true,
        })
        .then((response) => {
          this.projects = response.data;
          this.modifyData();
        })

        .catch((error) => {})
        .finally(() => {});
    },

    addProject(name, labels) {
      Http()
        .post(OCR_ENDPOINTS.projects, {
          name: name,
          annotationFieldList: labels,
        })
        .then((response) => {
          this.editProjectDetails = response.data;
          this.modifyNew(this.editProjectDetails);
          this.projects.unshift(this.editProjectDetails);
          this.$toast.success("Project added succesfully");
          this.displayProjectModal = false;
        })
        .catch((error) => {
          this.$toast.error(error.response.data);
        })
        .finally(() => {});
    },
  },
};
</script>
